import { autocompleteClasses, Components, Theme } from '@mui/material';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    listbox: ({ theme }) => ({
      [`& .${autocompleteClasses.option}[aria-selected="true"]`]: {
        backgroundColor: theme.featureFlags.panwRebrandStubYear
          ? `${theme.palette.input.selected} !important`
          : theme.palette.action.menuSelected,
      },
    }),
    // Hack to make medium chips in medium autocompletes appear small
    // Can be removed once MultiSelect has been backfilled and MUI's Autocomplete is no longer used directly
    tagSizeMedium: {
      height: '18px',
      margin: '2px',
      [`& .MuiChip-labelMedium`]: {
        fontSize: '12px',
        padding: '0 8px',
      },
      [`& .MuiSvgIcon-fontSizeMedium`]: {
        width: '16px',
        height: '16px',
        marginLeft: '-4px',
      },
    },
  },
};
